import App from './modules/App'

document.addEventListener('DOMContentLoaded', () => new App(), false)